import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsModels } from '@share-models';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import { EnableEscCloseDirective, UiButtonComponent } from '@ui';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';

@Component({
  selector: 'app-change-user-theme-modal',
  standalone: true,
  imports: [
    MatDialogClose,
    MatRadioButton,
    MatRadioGroup,
    TranslatePipe,
    ReactiveFormsModule,
    UiButtonComponent,
  ],
  templateUrl: './change-user-theme-modal.component.html',
  styleUrl: './change-user-theme-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class ChangeUserThemeModalComponent implements OnInit {
  public userThemeFormControl = new FormControl<string>('light', [
    Validators.required.bind(Validators),
  ]);
  public themeString = UserSettingsModels.themeString;
  public theme = {
    LIGHT: 'light',
    DARK: 'dark',
  } as const;

  private dialogRef = inject(MatDialogRef<ChangeUserThemeModalComponent>);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  public data = inject<{ settings: UserSettingsModels.UserSettingsDocument }>(
    MAT_DIALOG_DATA,
  );

  public ngOnInit(): void {
    this.userThemeFormControl.patchValue(
      this.data?.settings?.theme ?? this.theme.LIGHT,
    );
  }

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    const formValue = this.userThemeFormControl.value?.trim();
    if (!formValue) {
      return;
    }

    this.store$.dispatch(
      UserSettingsActions.startUpdateTheme({ theme: formValue }),
    );
    this.dialogRef.close();
  }
}
